import { Observable } from 'rxjs';
import type { AjaxResponse } from 'rxjs';

import { post } from 'epics/ajax';

export const fetchObjectsFromUrls = (urls: string[]) => {
    return (
        post(
            '/gateway/api/object-resolver/resolve/batch',
            urls.map((url) => ({
                resourceUrl: url,
            })),
            { 'Content-Type': 'application/json' }
        )
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .map(({ response }: AjaxResponse) => response)
            .catch((e) => Observable.throw(e))
    );
};
